import { render, staticRenderFns } from "./xuekepinggu.vue?vue&type=template&id=af8283a6&scoped=true"
import script from "./xuekepinggu.vue?vue&type=script&lang=js"
export * from "./xuekepinggu.vue?vue&type=script&lang=js"
import style0 from "./xuekepinggu.vue?vue&type=style&index=0&id=af8283a6&prod&lang=less&scoped=true"
import style1 from "./xuekepinggu.vue?vue&type=style&index=1&id=af8283a6&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af8283a6",
  null
  
)

export default component.exports